import axios from 'axios';
import BaseAPI from './base/base-api';

class OrderAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'order';
}

export default new OrderAPI();